import { DisclosureChevron, RowChevron, LinkChevron } from '../shared/ui/icons/ChevronIcons'
import { useEffect, useState } from 'react'
// SPEC-LOGIN-BOUNCE-AFTER-SUCCESS-01 (D-838): ここへ到達できたかどうかが押し戻しの判定点。
import { traceAuth, resetTraceId, TRACE } from '../lib/authTrace'
// SPEC-PATROL-OVERDUE-ALERT-V1 (D-505): 巡回間隔が空いた店舗を報告カード内に出す(場所はひろ指示)。
//   ★このコメントに報告カードの見出し文字列そのものを書かないこと(D-341 のテストが indexOf で位置を測っており衝突する)。
import { fetchPatrolOverdueStores, overdueLabel } from '../services/patrolOverdue'
// D-1122: 巡回もれの日数・報告の滞留の時間はアラート設定(app_config の alert_ 行)から読む。取れなければ既定値(今の値)。
import { useAlertThresholds } from '../lib/alertThresholds'
import { useNavigate } from 'react-router-dom'
import {
  getModuleTilesForRole,
  MANAGER_ROLES,
} from '../shared/auth/roles'
// D-1026: タナサポのタイルに SGP 要確認(未確認)の件数バッジ。入荷チェックの要確認レーンと同じ取得。
import { useSgpReviews } from '../hooks/useSgpReviews'
// SPEC-STORE-DAILY-REPORT-MODULE-01 (D-866): 直営店のバイトにだけマネサポタイルを「店舗」タブ経由で開く ctx。
import { useDirectOperatedStores } from '../shared/auth/useDirectOperatedStores'
import { MODULE_COLORS } from '../shared/ui/moduleColors'
import { HubIcon, HUB_TILE_ICON_PX, CalendarDaysIcon } from '../shared/ui/icons/HubIcons' // D-1013 / D-1113
import { openFromJst } from '../services/shiftRequests' // D-1113: 休み希望のカードの行き先(JST の翌月)
import { useRole } from '../shared/auth/useRole'
import { useAuth } from '../hooks/useAuth'
import { logout } from '../lib/auth/session'
import { markManualLogout } from '../lib/auth/faceIdAutoStart'
import DateTime from '../shared/ui/DateTime'
import { supabase } from '../lib/supabase'
import { logger } from '../lib/logger'
import { getCache, clearCache } from '../lib/prefetchCache'
import { isTestBuild } from '../lib/buildEnv' // SPEC-OCR-TEST-ENTRYPOINT-DEV-ONLY-01 (D-362): テスト版限定の入口判定
// SPEC-ALERT-ASSIGNED-STORES-AND-NAMES-01 (D-154) ITEM_1/ITEM_2
import { fetchLauncherAlerts, fetchAlertPrizeNames, fetchAllUnresolvedAlerts, groupAlertsByAreaStore, countAlertsByType, severityOf, SEVERITY_LABELS, contractorCanResolve } from '../services/boothAlerts'
import AlertTypeIcon from '../components/icons/AlertTypeIcon'
// SPEC-IN-APP-FEEDBACK-01 (D-852): 不具合・要望 の送信シート(入口はヘッダ右列のログアウトの下)。
import FeedbackSheet from '../components/FeedbackSheet'
import { useFeedbackReplyBadge } from '../hooks/useFeedbackReplyBadge'
// SPEC-LAUNCHER-UPDATE-NOTICE-01 (D-982): 「新しいバージョンがあります→タップで更新」。ログイン後ハブに常設。
import UpdateNotice from '../components/UpdateNotice'
// D-993: Face ID でログイン設定への入口(使える端末だけ)
import { isWebAuthnSupported } from '../lib/webauthn'
import { ClipboardListIcon, CircleCheckIcon } from '../shared/ui/icons/UiIcons' // D-1011 / D-1085(✓ → circle-check)
import UndoToast from '../shared/ui/UndoToast' // D-1130: 1 タップ完了の「元に戻す」
// D-1130: 完了できる行かの判定は報告一覧と同じ関数(prize_out_anomaly は管理者だけ・contractor はマスタ)。

// 未対応TODOインラインリスト用: booth_code 末尾 (例: MNK01-M02-B04 → B04) を取り出し
function boothLabel(boothNumber, boothCode) {
  if (boothNumber != null) return `B${String(boothNumber).padStart(2, '0')}`
  const m = typeof boothCode === 'string' ? boothCode.match(/-(B\d+)$/i) : null
  return m ? m[1] : boothCode
}

// SPEC-LAUNCHER-GREETING-ONELINE-01: ひろ報告 (app_feedback ec48592c, route /launcher)
//   「名前切れないけどさんが改行して高さが出た / 下の報告のために高さ抑えたい」への対応。
//   D-873 で truncate は外したが、break-words だけだと「さん」が単独で2行目に折り返り、
//   ヘッダの高さが伸びて下の報告一覧を押し下げていた。
//
//   実測 (2026-09-25, 実ブラウザ / 390x844): ヘッダ右列(ログアウト+「不具合・要望」入口、
//   D-852 で追加・本 spec のスコープ外)を差し引くと挨拶に残る実効幅は約 246px。
//   全角文字(ひらがな/カタカナ/漢字/全角記号)はほぼ font-size と同じ幅、半角文字
//   (半角スペース・半角カッコ・ラテン文字等)は実測で概ね 0.55 倍。単純な文字数だと
//   半角混在の名前(例:「本田 広宣」)で誤差が出るため、文字種で重み付けしたスコアで判定する。
//   スコア上限は実測値から 5px 分の安全マージンを引いて逆算(例: text-xl は 246px 幅で
//   実測スコア 12.55 の「本田 広宣」がマージン 1.6px しかなく際どかったため、1段階手前で縮める)。
//   下限は text-lg(18px)。text-lg でもスコア 13 を超える(=8全角文字級の長い名前など)場合は
//   物理的にこの幅へ1行で収まらない実測値のため、フォント短縮だけでは解決しない。
//   その場合は「名前+さん」の分割を許容して折り返す(D-873 と同じ「クリップしない/
//   横スクロールしない」を優先する最終手段。呼び出し側の JSX で nowrap を外す)。
function isNarrowChar(ch) {
  return ch.codePointAt(0) < 0x1100 // 半角スペース・半角カッコ・ラテン文字・数字など
}
function greetingWidthScore(text) {
  let score = 0
  for (const ch of text) score += isNarrowChar(ch) ? 0.55 : 1
  return score
}
// text-lg(18px)で 246px 幅の1行に収まるスコアの実測上限。これを超えたら nowrap を外し折り返しを許容する。
const GREETING_MAX_SCORE_AT_FLOOR = 13
const GREETING_SIZE_STEPS = [
  { maxScore: 10, cls: 'text-2xl' },
  { maxScore: 12, cls: 'text-xl' },
  { maxScore: Infinity, cls: 'text-lg' },
]
function greetingSizeClass(fullText) {
  const score = greetingWidthScore(fullText)
  const step = GREETING_SIZE_STEPS.find(s => score <= s.maxScore)
  return step ? step.cls : 'text-lg'
}
function greetingFitsOnOneLine(fullText) {
  return greetingWidthScore(fullText) <= GREETING_MAX_SCORE_AT_FLOOR
}

// D-1085: 7 日以上前の日付は JST で決める(timeZone 無しだと端末の時間帯になる)。テストのため export。
export function timeAgo(iso) {
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000)
  if (diff < 60)        return 'たった今'
  if (diff < 3600)      return `${Math.floor(diff / 60)}分前`
  if (diff < 86400)     return `${Math.floor(diff / 3600)}時間前`
  if (diff < 7 * 86400) return `${Math.floor(diff / 86400)}日前`
  return new Date(iso).toLocaleDateString('ja-JP', { timeZone: 'Asia/Tokyo' })
}

export default function Launcher({ env } = {}) {
  // ★D-838: /launcher に着いた = 押し戻されなかった。ここまで来たら 1 回の試行は成功なので
  //   足跡の ID を次へ回す(次のログインと混ざらないように)。
  useEffect(() => {
    traceAuth(TRACE.launcherReached, 'launcher_mounted', {})
    resetTraceId()
  }, [])
  const navigate = useNavigate()
  // SPEC-OCR-TEST-ENTRYPOINT-DEV-ONLY-01 (D-362): production 以外(preview/development)でのみ OCRテスト入口を出す。
  //   env 引数はテスト差し替え口(router からは無指定=__VERCEL_ENV__ 判定。undefined は安全側=非表示)。
  const showOcrTest = isTestBuild(env)
  const faceIdSupported = isWebAuthnSupported()
  const { role, staffName, loading } = useRole()
  const { staffId } = useAuth()
  // SPEC-LAUNCHER-GREETING-ONELINE-01: 挨拶文字列は「こんにちは、」+ 名前 + 「さん」の合計スコアでサイズを決める。
  const greetingName = staffName || 'ゲスト'
  const greetingFullText = `こんにちは、${greetingName}さん`
  const greetingSize = greetingSizeClass(greetingFullText)
  // 下限サイズでも1行に収まらない極端な名前だけ nowrap を外し、折り返し(最終手段)を許容する。
  const greetingNameNowrap = greetingFitsOnOneLine(greetingFullText)
  // D-866: 直営店のバイトにだけマネサポタイルを開く ctx(role が確定する前は role=null で即 loading:false)。
  //   gate_3 指摘 5: 取得失敗は「直営店なし」と区別し、タイルは出さず(fail-closed)再試行の帯を出す。
  const { storeCodes: directStores, error: directError, retry: retryDirect } = useDirectOperatedStores(role)
  // D-1113: 「来月の休み希望を出す」のカードは直営店の staff・manager にだけ。staff は上の結果、
  //   manager は useDirectOperatedStores が呼ばない(staff 以外は空)のでここで 1 回だけ取る。取れなければカードを出さない。
  const [managerDirectStores, setManagerDirectStores] = useState([])
  useEffect(() => {
    if (role !== 'manager' || typeof supabase?.rpc !== 'function') { setManagerDirectStores([]); return () => {} }
    let cancelled = false
    Promise.resolve()
      .then(() => supabase.rpc('current_staff_direct_stores'))
      .then(res => { if (!cancelled) setManagerDirectStores(!res?.error && Array.isArray(res?.data) ? res.data : []) })
      .catch(() => { if (!cancelled) setManagerDirectStores([]) })
    return () => { cancelled = true }
  }, [role])
  const shiftRequestStores = role === 'staff' ? directStores : role === 'manager' ? managerDirectStores : []

  async function handleLogout() {
    // D-993b: 明示ログアウトの印(このタブだけ)。ログイン画面は Face ID を自動で始めない(押した直後に入り直さない)。
    //   ★アイドル 30 分のログアウト(useIdleLogout)では立てない = 戻ってきたら自動で Face ID。
    markManualLogout()
    await logout()
    sessionStorage.removeItem('clawops_staff')
    window.location.replace('/login')
  }

  const now = new Date()
  const [alerts, setAlerts]         = useState([])
  // D-505: 巡回もれ店舗(サーバでライブ計算。巡回すれば次の取得で自動的に消える)。
  const [overdueStores, setOverdueStores] = useState([])
  // D-1122: 設定を読み終えてから巡回もれを引く(既定の 5 日で先に引くと、表示の「n日以上」と RPC の値がずれる)。
  const { thresholds: alertT, loading: alertTLoading } = useAlertThresholds()
  const overdueDays = alertT.alert_patrol_overdue_days
  const [storeMap, setStoreMap]     = useState({})
  const [machineMap, setMachineMap] = useState({})
  const [boothMap, setBoothMap]     = useState({})
  const [expandedId, setExpandedId] = useState(null)
  const [resolvingId, setResolvingId] = useState(null)
  // D-1085: 対応完了にできなかった alert_id(行の中に知らせを出す)。成功したら外す。
  const [resolveFailedIds, setResolveFailedIds] = useState(() => new Set())
  const [prizeMap, setPrizeMap]     = useState({}) // D-154 ITEM_2: alert_id -> 景品名
  // D-295: エリア/店舗グルーピングと種別チップ絞り込み。
  const [areaMap, setAreaMap]       = useState({}) // store_code -> area
  const [typeFilter, setTypeFilter] = useState(null) // 選択中の type_code(単一トグル)
  const [expandedAreas, setExpandedAreas]   = useState(() => new Set())
  const [expandedStores, setExpandedStores] = useState(() => new Set())
  const [ideaOpen, setIdeaOpen]             = useState(false) // D-343: 改善ブロックは既定で折りたたみ
  const [faultOpen, setFaultOpen]           = useState(false) // D-344: 不具合ブロックも既定で折りたたみ(改善と同形)
  const [overdueOpen, setOverdueOpen]       = useState(false) // D-507: 巡回もれも既定で折りたたみ(件数が多いため。実測 27 件)
  const [feedbackOpen, setFeedbackOpen]     = useState(false) // D-852: 不具合・要望シート
  const replyBadge = useFeedbackReplyBadge(staffId)           // D-889: 返信ありで未読の件数
  // D-1026: 入荷チェック(/stock/arrival = ManagerRoute)を開ける人にだけ数える・出す。0 件・取得失敗なら出さない。
  const sgpReview = useSgpReviews({ enabled: MANAGER_ROLES.includes(role) })

  // D-1130: 管理者だけの種別・contractor の完了不可種別は ✓ も完了も出さない。contractor のときだけマスタ(alert_types)を引く。
  const [resolvableCodes, setResolvableCodes] = useState(null)
  useEffect(() => {
    if (role !== 'contractor') return undefined
    let cancelled = false
    // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): AlertListPage と同じ取得
    supabase.from('alert_types').select('type_code, contractor_resolvable').then(({ data }) => {
      if (cancelled) return
      setResolvableCodes(new Set((data ?? []).filter(t => t.contractor_resolvable).map(t => t.type_code)))
    })
    return () => { cancelled = true }
  }, [role])
  // D-1130: 直前の完了の「元に戻す」(5 秒)。{ id, message, error?, alert, index }
  const [undoToast, setUndoToast] = useState(null)
  const [undoBusy, setUndoBusy] = useState(false)

  async function handleUndoResolve() {
    const t = undoToast
    if (!t?.alert || undoBusy) return
    setUndoBusy(true)
    try {
      const { error } = await supabase.from('booth_alerts').update({
        resolved: false, resolved_at: null, resolved_by: null,
      }).eq('alert_id', t.alert.alert_id)
      if (error) throw error
      setAlerts(prev => {
        if (prev.some(a => a.alert_id === t.alert.alert_id)) return prev
        const n = [...prev]; n.splice(Math.min(t.index, n.length), 0, t.alert); return n
      })
      setUndoToast(null)
    } catch (e) {
      logger.warn('launcher_alert_undo_failed', { alert_id: t.alert.alert_id, message: String(e?.message ?? e ?? '').slice(0, 200) })
      setUndoToast(prev => (prev ? { ...prev, error: '元に戻せませんでした。報告一覧の履歴から確かめてください' } : prev))
    } finally {
      setUndoBusy(false)
    }
  }

  async function handleResolveAlert(alertId) {
    if (resolvingId) return
    setResolvingId(alertId)
    try {
      const { error } = await supabase.from('booth_alerts').update({
        resolved:    true,
        resolved_at: new Date().toISOString(),
        resolved_by: staffId ?? null,
      }).eq('alert_id', alertId)
      if (error) throw error
      const index = alerts.findIndex(a => a.alert_id === alertId)
      const target = alerts[index]
      setAlerts(prev => prev.filter(a => a.alert_id !== alertId))
      setExpandedId(null)
      if (target) setUndoToast({ id: `${alertId}-${Date.now()}`, message: '対応完了にしました', alert: target, index })
      setResolveFailedIds(prev => { if (!prev.has(alertId)) return prev; const n = new Set(prev); n.delete(alertId); return n })
    } catch (e) {
      // D-1085: 失敗を黙って捨てない。行の中に出す(console.error はやめて logger.warn = console.warn)。
      logger.warn('launcher_alert_resolve_failed', { alert_id: alertId, message: String(e?.message ?? e ?? '').slice(0, 200) })
      setResolveFailedIds(prev => new Set(prev).add(alertId))
    } finally {
      setResolvingId(null)
    }
  }

  useEffect(() => {
    if (!loading && !role) {
      navigate('/login', { replace: true })
    }
  }, [loading, role, navigate])

  // D-505: 巡回もれ店舗の取得。ログイン後に 1 回だけ引く(アラート取得とは独立させ、失敗しても他をブロックしない)。
  //   サーバ側 fn_store_patrol_gaps がライブ計算するため、キャッシュも解消処理も持たない。
  useEffect(() => {
    if (!role || alertTLoading) return
    let cancelled = false
    fetchPatrolOverdueStores({ thresholdDays: overdueDays }).then(({ rows }) => {
      if (!cancelled) setOverdueStores(rows)
    }).catch(() => { /* 取得失敗は 0 件扱い。管理ハブ本体は出す(D-160 の fail-safe 思想) */ })
    return () => { cancelled = true }
  }, [role, alertTLoading, overdueDays])

  // 気づきリストをハブに直表示するため、件数だけでなく上位レコード+ラベルマップを取る
  // SPEC-LOGIN-PREFETCH-ON-STAFF-SELECT-01: staff tap 時に prefetch 済みならキャッシュヒット → 即表示。
  useEffect(() => {
    if (!role) return

    // D-295 IMPL_1: admin/manager は全店の未対応を見る(担当店絞りを解除)。それ以外は従来どおり担当店のみ。
    const isAllScope = role === 'admin' || role === 'manager'

    const cached = getCache(staffId)
    if (cached?.ready) {
      const sm = {}; cached.stores.forEach(s => { sm[s.store_code] = s.store_name })
      const mm = {}; cached.machines.forEach(x => { mm[x.machine_code] = x.machine_name || x.machine_code })
      const bm = {}; cached.booths.forEach(x => { bm[x.booth_code] = x.booth_number })
      setStoreMap(sm)
      setMachineMap(mm)
      setBoothMap(bm)
      setAreaMap({}) // D-295 IMPL_2: cached.stores に area 無し→空で始め、後の stores 取得で埋める(キャッシュ形は変えない)
      if (isAllScope) {
        // D-295: admin/manager はキャッシュの担当絞り alert ではなく全店を取得
        fetchAllUnresolvedAlerts().then(al => { setAlerts(al); fetchAlertPrizeNames(al).then(setPrizeMap) })
      } else {
        // D-154 ITEM_1: キャッシュ済み alert も担当店舗(cached.staff_stores)で絞る。
        const allowed = new Set((cached.staff_stores ?? []).map(r => r.store_code).filter(Boolean))
        const filtered = (cached.booth_alerts ?? []).filter(a => allowed.has(a.store_code))
        setAlerts(filtered)
        fetchAlertPrizeNames(filtered).then(setPrizeMap) // D-154 ITEM_2: 景品名
      }
      clearCache()
      // D-298 IMPL_1(原因修正): prefetch は未認証(anon)時に走ることがあり、stores/machines は RLS(authenticated_select のみ)で
      //   [] になり得る。よって cached.stores/machines から作った storeMap/machineMap は欠けることがある(=見出し/行がコード表示になる真因)。
      //   authenticated で stores/machines を取り直し、届いた時点で storeMap/machineMap/areaMap を店舗名・機械名に差し替える(キャッシュ形は不変)。
      // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
      supabase.from('stores').select('store_code,store_name,area').then(({ data }) => {
        if (!data) return
        const sm2 = {}, am = {}
        data.forEach(s => { sm2[s.store_code] = s.store_name; am[s.store_code] = s.area ?? null })
        setStoreMap(sm2); setAreaMap(am)
      })
      // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
      supabase.from('machines').select('machine_code,machine_name').then(({ data }) => {
        if (!data) return
        const mm2 = {}; data.forEach(x => { mm2[x.machine_code] = x.machine_name || x.machine_code }); setMachineMap(mm2)
      })
      return
    }

    // D-295 IMPL_1: role を渡す。admin/manager=全店、それ以外=担当店(担当0件は空・全件フォールバックしない)。
    fetchLauncherAlerts(staffId, role).then(({ alerts: al }) => {
      setAlerts(al)
      fetchAlertPrizeNames(al).then(setPrizeMap) // D-154 ITEM_2: 景品名
    })
    // D-295 IMPL_2: 既存の stores 取得に area を加えて storeMap と areaMap を作る(追加問合せなし)。
    // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
    supabase.from('stores').select('store_code,store_name,area').then(({ data }) => {
      if (!data) return
      const sm = {}, am = {}
      data.forEach(s => { sm[s.store_code] = s.store_name; am[s.store_code] = s.area ?? null })
      setStoreMap(sm); setAreaMap(am)
    })
    // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
    supabase.from('machines').select('machine_code,machine_name').then(({ data }) => {
      if (!data) return
      const m = {}; data.forEach(x => { m[x.machine_code] = x.machine_name || x.machine_code })
      setMachineMap(m)
    })
    // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
    supabase.from('booths').select('booth_code,booth_number').then(({ data }) => {
      if (!data) return
      const m = {}; data.forEach(x => { m[x.booth_code] = x.booth_number })
      setBoothMap(m)
    })
  }, [role, staffId])

  // D-295 IMPL_7: 絞り込み対象の種別が0件になったら自動解除(万一の空表示防止)。
  useEffect(() => {
    if (typeFilter && !alerts.some(a => a.type_code === typeFilter)) setTypeFilter(null)
  }, [alerts, typeFilter])

  // D-295 IMPL_6: 表示時に launcher_alerts_rendered(件数と段数、scope。個人情報/店舗名は含めない)。
  useEffect(() => {
    if (!role) return
    const g = groupAlertsByAreaStore(alerts, storeMap, areaMap)
    const store_count = g.reduce((n, ar) => n + ar.stores.length, 0)
    logger.info('launcher_alerts_rendered', {
      total: alerts.length,
      area_count: g.length,
      store_count,
      scope: (role === 'admin' || role === 'manager') ? 'all' : 'assigned',
    })
  }, [alerts, storeMap, areaMap, role])

  const unresolvedCount = alerts.length

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-muted">読み込み中...</div>
    )
  }
  if (!role) return null

  const moduleTiles = getModuleTilesForRole(role, directStores)

  // D-295: 種別チップは全 alerts ベース(位置固定・畳んでも何が何件か分かる)。グルーピングは絞り込み後で段が浅くなる。
  const typeCounts = countAlertsByType(alerts)
  const activeFilter = (typeFilter && typeCounts.some(t => t.type_code === typeFilter)) ? typeFilter : null
  const visibleAlerts = activeFilter ? alerts.filter(a => a.type_code === activeFilter) : alerts
  // SPEC-REPORT-SEVERITY-3CLASS-01 (D-343): 区分(severity)で3ブロックに分割。null(meter_anomaly 等)はどのブロックにも入れない。
  const bySeverity = { stopped: [], fault: [], idea: [] }
  for (const a of visibleAlerts) { const s = severityOf(a); if (bySeverity[s]) bySeverity[s].push(a) }
  const shownCount = bySeverity.stopped.length + bySeverity.fault.length + bySeverity.idea.length

  const countBadge = (n) => (
    <span className="shrink-0 min-w-[22px] h-[22px] px-1 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">{n}</span>
  )

  // D-294 の行(アコーディオン+対応完了+ブースへ移動)をそのまま各段の末端で再利用。
  // D-343: staleHours を渡すと、created_at からその時間を超えた行を強調表示(停止中24h/不具合7d、改善は渡さない)。
  const renderAlertRow = (a, staleHours = null) => {
    const isOpen = expandedId === a.alert_id
    const isResolving = resolvingId === a.alert_id
    const stale = staleHours != null && (Date.now() - new Date(a.created_at).getTime()) > staleHours * 3600 * 1000
    const canResolve = contractorCanResolve(role, a.type_code, resolvableCodes)
    const toggle = () => setExpandedId(prev => prev === a.alert_id ? null : a.alert_id)
    return (
      <div key={a.alert_id} data-testid={stale ? `launcher-alert-stale-${a.alert_id}` : undefined}>
        <div className={`flex items-center ${stale ? 'border-l-4 border-l-red-500 bg-red-500/10' : ''}`}>
        <button
          type="button"
          onClick={toggle}
          className="flex-1 min-w-0 flex items-center gap-2 pl-3 pr-1 py-1.5 min-h-[44px] text-left active:bg-bg/40"
          aria-expanded={isOpen}
        >
          {/* D-308: 単色シルエット(icon_key)。無ければ icon_emoji フォールバック。色は color_hex。 */}
          <AlertTypeIcon typeCode={a.type_code} iconKey={a.alert_types?.icon_key} iconEmoji={a.alert_types?.icon_emoji} color={a.alert_types?.color_hex ?? '#cbd5e1'} size={24} className="shrink-0" />
          <span className="text-xl font-bold shrink-0" style={{ color: a.alert_types?.color_hex ?? '#cbd5e1' }}>
            {a.alert_types?.label ?? a.type_code}
          </span>
          {/* D-298 IMPL_2: 店舗は見出しで確定済み=行では出さない。機械名(人が読める名)+ブース。機械名が取れなければブースだけ。 */}
          <span className="text-xl text-text truncate flex-1 leading-tight" data-testid={`launcher-alert-head-${a.alert_id}`}>
            {machineMap[a.machine_code]
              ? `${machineMap[a.machine_code]} ${boothLabel(boothMap[a.booth_code], a.booth_code)}`
              : boothLabel(boothMap[a.booth_code], a.booth_code)}
          </span>
          <span className="text-lg text-muted shrink-0">{timeAgo(a.created_at)}</span>
        </button>
        {/* D-1130: 閉じたまま 1 タップで完了(展開しない)。完了できない行には出さない。 */}
        {canResolve && (
          <button
            type="button"
            onClick={() => handleResolveAlert(a.alert_id)}
            disabled={isResolving}
            data-testid={`launcher-alert-quick-resolve-${a.alert_id}`}
            aria-label="対応完了にする"
            className="shrink-0 min-h-[44px] min-w-[44px] flex items-center justify-center text-emerald-400 active:text-emerald-300 disabled:opacity-50"
          >
            <CircleCheckIcon size={28} />
          </button>
        )}
        <button type="button" onClick={toggle} tabIndex={-1} aria-label={isOpen ? '閉じる' : '開く'}
          className="shrink-0 min-h-[44px] min-w-[44px] flex items-center justify-center">
          <DisclosureChevron open={isOpen} className="text-muted" />
        </button>
        </div>
        {isOpen && (
          <div className="px-3 pb-3 pt-1 bg-bg/60 text-text">
            {/* D-298 IMPL_4: 展開ではブースと機械名を完全形で補完(行で省略された分)。ID は出さない。 */}
            <p className="text-xl leading-snug" data-testid={`launcher-alert-booth-${a.alert_id}`}>
              {machineMap[a.machine_code] ? `${machineMap[a.machine_code]} / ` : ''}{boothLabel(boothMap[a.booth_code], a.booth_code)}
            </p>
            {prizeMap[a.alert_id] && (
              <p className="text-xl text-text/90 mt-0.5 leading-snug" data-testid={`launcher-alert-prize-${a.alert_id}`}>
                {prizeMap[a.alert_id]}
              </p>
            )}
            {a.note && (
              <p className="text-xl text-text/80 mt-1 leading-snug whitespace-pre-wrap">{a.note}</p>
            )}
            {/* D-294 IMPL_3: 左=ブースへ移動(resolved にしない・弱い見た目)、右=対応完了にする(色/文言不変)。 */}
            <div className="mt-2 flex gap-2">
              <button
                type="button"
                onClick={() => {
                  logger.info('booth_alert_navigated', { alert_id: a.alert_id, booth_code: a.booth_code, source: 'launcher' })
                  navigate(`/clawsupport/booth/${a.booth_code}`)
                }}
                data-testid={`launcher-alert-goto-${a.alert_id}`}
                className="shrink-0 min-h-[44px] px-4 py-3 rounded-xl border border-slate-500 bg-slate-700/60 text-slate-200 text-lg font-bold active:bg-slate-700"
              >
                ブースへ移動
              </button>
              {canResolve && (
              <button
                type="button"
                onClick={() => handleResolveAlert(a.alert_id)}
                disabled={isResolving}
                data-testid={`launcher-alert-resolve-${a.alert_id}`}
                className="flex-1 min-h-[44px] py-3 rounded-xl bg-emerald-600 text-white text-xl font-bold active:bg-emerald-700 disabled:opacity-50"
              >
                {isResolving ? '更新中…' : (
                  <span className="inline-flex items-center justify-center gap-2">
                    {/* D-1085: 字の ✓ → Lucide circle-check */}
                    <CircleCheckIcon size={24} className="shrink-0" />
                    <span>対応完了にする</span>
                  </span>
                )}
              </button>
              )}
            </div>
          </div>
        )}
        {resolveFailedIds.has(a.alert_id) && (
          <p role="alert" data-testid={`launcher-alert-resolve-error-${a.alert_id}`}
            className="mx-3 mb-2 rounded-lg bg-red-500/15 px-3 py-2 text-base text-red-200">
            対応完了にできませんでした。通信を確かめてもう一度
          </p>
        )}
      </div>
    )
  }

  const renderStoreLevel = (stores, staleHours = null) => stores.map(s => {
    const open = expandedStores.has(s.store_code)
    return (
      <div key={s.store_code} data-testid={`launcher-store-group-${s.store_code}`}>
        <button
          type="button"
          data-testid={`launcher-store-head-${s.store_code}`}
          aria-expanded={open}
          onClick={() => setExpandedStores(prev => { const n = new Set(prev); n.has(s.store_code) ? n.delete(s.store_code) : n.add(s.store_code); return n })}
          className="w-full flex items-center gap-2 pl-6 pr-3 py-1.5 min-h-[44px] text-left bg-bg/30 active:bg-bg/50"
        >
          {/* D-298 IMPL_1: 店舗名。名前が無いときはコードのみ(D-298 AC2)。
              D-1085: 名前の横に添えていたコードは外す(画面にコードを出さない、ui.md / D-1011)。 */}
          <span className="flex-1 truncate">
            <span className="text-lg font-bold">{s.store_name}</span>
          </span>
          {countBadge(s.count)}
          <DisclosureChevron open={open} className="text-muted" />
        </button>
        {open && <div className="pl-3">{s.alerts.map(a => renderAlertRow(a, staleHours))}</div>}
      </div>
    )
  })

  // D-343: 1区分ぶんの alert を D-295 のエリア/店舗グルーピングで描画(段は分布で自動省略。旧・単一リストの showArea 分岐をこの中に移設)。
  const renderGroupedAlerts = (arr, staleHours = null) => {
    const grps = groupAlertsByAreaStore(arr, storeMap, areaMap)
    if (grps.length >= 2) {
      return grps.map(g => {
        const open = expandedAreas.has(g.area)
        return (
          <div key={g.area} data-testid={`launcher-area-group-${g.area}`}>
            <button
              type="button"
              data-testid={`launcher-area-head-${g.area}`}
              aria-expanded={open}
              onClick={() => setExpandedAreas(prev => { const n = new Set(prev); n.has(g.area) ? n.delete(g.area) : n.add(g.area); return n })}
              className="w-full flex items-center gap-2 px-3 py-2 min-h-[44px] text-left bg-surface active:bg-bg/40"
            >
              <span className="text-xl font-bold flex-1 truncate">{g.area}</span>
              {countBadge(g.count)}
              <DisclosureChevron open={open} className="text-muted" />
            </button>
            {open && <div>{renderStoreLevel(g.stores, staleHours)}</div>}
          </div>
        )
      })
    }
    if (grps[0]?.stores.length >= 2) return renderStoreLevel(grps[0].stores, staleHours)
    return (grps[0]?.stores[0]?.alerts ?? []).map(a => renderAlertRow(a, staleHours))
  }

  return (
    <div className="h-svh flex flex-col bg-bg text-text">
      {/* SPEC-LAUNCHER-ALERTS-STICKY-HEADER-01 (D-341): 上部固定(shrink-0)= ヘッダ+ログアウト+タイル+報告タイトル/チップ。
          下部スクロール(flex-1)= 福岡市以下のリストのみ。root の h-svh(D-340 CLASS_B 対応)は維持し、スクロール範囲だけ是正。 */}
      <div className="shrink-0">
      <div className="px-4 pt-10 pb-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-muted text-lg">
            <DateTime value={now} format="date" />　<DateTime value={now} format="time" />
          </p>
          {/* SPEC-LAUNCHER-GREETING-ONELINE-01 (ひろ報告 app_feedback ec48592c): D-873 で truncate を外し
              全文表示にしたところ、「さん」だけが2行目に折り返ってヘッダが高くなり下の報告一覧を
              押し下げる副作用が出た。挨拶の合計スコア(greetingWidthScore)でフォントを段階縮小
              (greetingSizeClass、下限 text-lg)しつつ、下限でも1行に収まる名前(greetingNameNowrap)
              だけ「名前+さん」を whitespace-nowrap でひとまとまりにして分割折り返りを防ぐ。
              下限まで縮めても収まらない極端な長さのときは nowrap を外し、break-words で
              折り返しを許容する(最終手段。横スクロールは発生させない=親は min-w-0 のまま)。 */}
          <h1 data-testid="launcher-greeting" className={`${greetingSize} font-bold mt-1 break-words leading-tight`}>
            こんにちは、<span className={greetingNameNowrap ? 'whitespace-nowrap' : undefined}>{greetingName}さん</span>
          </h1>
        </div>
        {/* D-852: 右列 = ログアウト + その下に「不具合・要望」。挨拶の左列(日時 28 + 4 + 挨拶 36 = 68px)より高くしない:
            ログアウト(mt-1 4 + 28)+ 入口 h-11(44)- -mb-2(8)= 68px。当たり判定は 44px のまま、下の pb-4 の余白へはみ出すだけ。
            D-1085: ログアウトの押せる範囲も 44px に。字の位置はそのまま、上のヘッダの pt-10 の余白へ 12px はみ出す:
            -mt-3(-12)+ min-h 44(pt-5 20 + 字 20 + pb-1 4)= 32 = 前の mt-1 4 + 28。右列は 68px のまま、下の入口とは重ならない。 */}
        <div className="shrink-0 flex flex-col items-end">
          {/* D-341: ログアウトを最下部→上部固定エリアの空きへ移設(handleLogout は不変・位置のみ)。 */}
          <button
            type="button"
            onClick={handleLogout}
            data-testid="launcher-logout"
            className="shrink-0 -mt-3 min-h-[44px] pt-5 pb-1 text-sm leading-5 text-muted hover:opacity-80 transition-opacity px-2"
          >
            ログアウト
          </button>
          {/* D-889: 返信(対応済み)で まだ見ていない件数をバッジで出す。0 件・取得失敗なら出さない。 */}
          <button
            type="button"
            data-testid="launcher-feedback-open"
            onClick={() => setFeedbackOpen(true)}
            aria-label={replyBadge.count > 0 ? `不具合・要望(返信 ${replyBadge.count} 件)` : undefined}
            className="relative shrink-0 h-11 -mb-2 px-2 text-sm text-muted underline underline-offset-4 decoration-dotted active:opacity-70 whitespace-nowrap"
          >
            不具合・要望
            {replyBadge.count > 0 && (
              <span data-testid="launcher-feedback-badge"
                className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[11px] font-bold leading-[18px] text-center no-underline">
                {replyBadge.count > 99 ? '99+' : replyBadge.count}
              </span>
            )}
          </button>
        </div>
      </div>

      <div className="px-4 space-y-3">
        {/* D-982: 更新通知は固定領域の最上部(タイルより上)。タップで更新のみ、自動適用しない。 */}
        <UpdateNotice />
        {directError && (
          <div data-testid="launcher-direct-stores-error" className="flex items-center gap-3 px-4 py-2 rounded-xl border border-red-400/40">
            <p className="flex-1 min-w-0 text-sm text-red-400">店舗の権限を読み込めませんでした</p>
            <button type="button" data-testid="launcher-direct-stores-retry" onClick={retryDirect}
              className="shrink-0 min-h-[44px] px-4 rounded-lg bg-blue-600 text-white text-sm font-bold">
              再試行
            </button>
          </div>
        )}
        {moduleTiles.map(tile => {
          const badgeCount = tile.key === 'tanasupport' ? sgpReview.count : 0
          return (
          <button
            key={tile.key}
            type="button"
            data-testid={`launcher-tile-${tile.key}`}
            onClick={() => navigate(tile.path)}
            aria-label={badgeCount > 0 ? `${tile.label}(SGP 要確認 ${badgeCount} 件)` : undefined}
            className="relative w-full flex items-center gap-3 px-4 py-3 rounded-2xl bg-surface border border-border text-left active:scale-[0.98] transition-transform min-h-[88px]"
            style={{ borderLeftWidth: 4, borderLeftStyle: 'solid', borderLeftColor: MODULE_COLORS[tile.key] ?? '#888899' }}
          >
            {/* D-1013 (ひろ選択): モジュールの線のアイコン(roles.js の tile.icon)をモジュール色で。 */}
            <span data-testid="launcher-module-icon" className="shrink-0 flex items-center" style={{ color: MODULE_COLORS[tile.key] ?? '#888899' }}>
              <HubIcon name={tile.icon} size={HUB_TILE_ICON_PX} />
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-3xl font-bold leading-tight text-text">{tile.label}</p>
              <p className="text-lg text-muted mt-1 leading-snug">{tile.desc}</p>
            </div>
            <RowChevron />
            {/* D-1026: 不具合・要望のバッジ(D-889)と同じ形の赤丸。0 件なら出さない。 */}
            {badgeCount > 0 && (
              <span data-testid={`launcher-tile-badge-${tile.key}`}
                className="absolute -top-1.5 -right-1.5 min-w-[24px] h-[24px] px-1.5 rounded-full bg-red-600 text-white text-xs font-bold leading-[24px] text-center">
                {badgeCount > 99 ? '99+' : badgeCount}
              </span>
            )}
          </button>
          )
        })}

        {/* D-1113: 直営店の staff・manager にだけ 1 枚。ログインしたら名前を選んで出せる(共有アカウントのため)。
            店が 1 つならその店の翌月の休み希望へ、2 つ以上なら店舗タブ(各店の「休み希望」のタイル)へ。 */}
        {shiftRequestStores.length > 0 && (
          <button
            type="button"
            data-testid="launcher-card-shift-request"
            onClick={() => navigate(shiftRequestStores.length === 1
              ? `/admin/store/${shiftRequestStores[0]}/requests/${openFromJst()}`
              : '/admin/store')}
            className="w-full flex items-center gap-3 px-4 py-2 rounded-2xl bg-surface border border-border text-left active:scale-[0.98] transition-transform min-h-[56px]"
          >
            <span className="shrink-0 flex items-center text-emerald-400">
              <CalendarDaysIcon size={24} />
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-lg font-bold leading-tight text-text">来月の休み希望を出す</p>
              <p className="text-sm text-muted leading-snug">名前を選んで出せます</p>
            </div>
            <RowChevron />
          </button>
        )}

        {/* SPEC-OCR-TEST-ENTRYPOINT-DEV-ONLY-01 (D-362): テスト版(preview/development)限定の OCRテスト入口。
            本番(production / __VERCEL_ENV__ undefined)では描画しない。既存タイル(moduleTiles)には一切触れず末尾に追加のみ。
            ロール制限なし(テストビルド内では誰でも可)。「TEST」バッジで本番機能と見分けられるようにする。 */}
        {showOcrTest && (
          <button
            type="button"
            data-testid="launcher-tile-ocr-test"
            onClick={() => navigate('/ocr-test')}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-2xl bg-surface border border-border text-left active:scale-[0.98] transition-transform min-h-[88px]"
            style={{ borderLeftWidth: 4, borderLeftStyle: 'solid', borderLeftColor: '#a855f7' }}
          >
            <div className="flex-1 min-w-0">
              <p className="text-3xl font-bold leading-tight text-text">
                OCRテスト
                <span className="ml-2 align-middle text-xs font-bold text-pink-400/90 bg-pink-950/40 rounded px-1.5 py-0.5">TEST</span>
              </p>
              <p className="text-lg text-muted mt-1 leading-snug">OCR精度テスト(テスト版限定)</p>
            </div>
            <RowChevron />
          </button>
        )}

        {/* 集金は J-NAV-ORPHANS-fix-02 でマネサポ「集金」タブ (Hub) に正式移設、Launcher からは再度削除済。
            動線: マネサポ → 集金タブ → 集金帳票 / 集金フラグ編集 / 集金履歴 */}

      </div>{/* /タイル群(px-4 space-y-3) */}

      {/* 未対応TODO インライン accordion (ad-hoc 2026-05-30 ヒロ Discord 依頼):
          collapsed = 分類 + 店舗名 + 経過時間 / expanded = 機械名/B番号 + note + ✓対応完了。
          D-341: タイトル+件数+一覧+種類チップ は固定領域(card 上端)、リストは下のスクロール領域。 */}
      <div className="px-4 pt-3">
        <div className="bg-surface border border-border rounded-t-2xl">
          <div className="px-4 pt-3 pb-2 flex items-center gap-2">
            {/* D-1011: 📋 → Lucide clipboard-list(線のアイコン) */}
            <ClipboardListIcon size={26} className="shrink-0 text-muted" />
            <p className="text-2xl font-bold text-text">未対応の報告</p>
            {unresolvedCount > 0 && (
              <span className="shrink-0 min-w-[24px] h-[24px] px-1.5 bg-red-500 text-white text-sm font-bold rounded-full flex items-center justify-center">
                {unresolvedCount}
              </span>
            )}
            <button
              type="button"
              onClick={() => navigate('/clawsupport/alerts')}
              data-testid="launcher-alerts-more"
              className="ml-auto min-h-[44px] -my-1.5 text-lg text-blue-400 active:text-blue-300"
            >
              一覧<LinkChevron />
            </button>
          </div>
          {/* D-295 IMPL_7: 種別チップ(常時・sort_order 固定・count>0のみ・横スクロールで折り返さない)。タップで単一トグル絞り込み。 */}
          {typeCounts.length > 0 && (
            <div data-testid="launcher-type-chips" className="px-4 pb-2 flex gap-2 overflow-x-auto">
              {typeCounts.map(t => {
                const active = activeFilter === t.type_code
                return (
                  <button
                    key={t.type_code}
                    type="button"
                    data-testid={`launcher-type-chip-${t.type_code}`}
                    aria-pressed={active}
                    onClick={() => setTypeFilter(prev => prev === t.type_code ? null : t.type_code)}
                    className="shrink-0 min-h-[44px] px-3 rounded-full text-base font-bold flex items-center gap-1 border whitespace-nowrap"
                    style={active ? { background: t.color, borderColor: t.color, color: '#000' } : { borderColor: t.color, color: t.color }}
                  >
                    {/* D-308: シルエット。チップの文字色(currentColor)を継承=active時#000/非active時 type色。 */}
                    <AlertTypeIcon typeCode={t.type_code} iconKey={t.iconKey} iconEmoji={t.icon} size={18} className="shrink-0" />
                    <span>{t.label}</span>
                    <span className="tabular-nums">{t.count}</span>
                  </button>
                )
              })}
            </div>
          )}
        </div>{/* /card-top(bg-surface rounded-t-2xl) */}
      </div>{/* /報告ヘッダ ラッパ(px-4 pt-3) */}
      </div>{/* /固定領域(shrink-0) */}

      {/* D-341: スクロール領域=福岡市以下のリストのみ。旧・内側 52vh 制限を撤廃し残り画面全部を使う(二重スクロールにしない=CLASS_B の単一スクロール親)。 */}
      <div className="flex-1 min-h-0 overflow-y-auto list-scroll px-4">
        <div className="bg-surface border border-t-0 border-border rounded-b-2xl overflow-hidden">
          {/* D-505: 巡回もれは alert とは別系統なので、alert が 0 件でもブロックを出せるように条件へ含める。
              両方 0 件のときだけ「ありません」を出す(巡回もれだけ有るのに空表示になるのを防ぐ)。 */}
          {shownCount === 0 && overdueStores.length === 0 ? (
            <p className="text-center text-muted text-xl py-5">未対応のアラートはありません</p>
          ) : (
            <div
              data-testid="launcher-alerts-scroll"
              className="divide-y divide-border/70"
            >
              {/* SPEC-REPORT-SEVERITY-3CLASS-01 (D-343) UI_1: 上から 停止中 / 不具合 / 改善 の3ブロック。0件のブロックは丸ごと非表示。 */}

              {/* SPEC-PATROL-OVERDUE-ALERT-V1 (D-505): 巡回もれ。停止中より上=最初に目に入る位置。
                  0 件ならブロックごと出さない(常時表示の警告は無視される = D-406 の屍)。
                  タップで当該店舗ページへ(既存の「ブースへ移動」と同型の遷移)。 */}
              {overdueStores.length > 0 && (
                <div data-testid="launcher-patrol-overdue">
                  {/* D-507: 件数が多い(実測 27 件)ため既定で折りたたむ。開閉の作法は fault/idea ブロックと同一。
                      畳んでいる間も件数バッジは出す(何件溜まっているかは開かなくても分かる)。 */}
                  <button
                    type="button"
                    data-testid="launcher-patrol-overdue-toggle"
                    aria-expanded={overdueOpen}
                    onClick={() => setOverdueOpen(v => !v)}
                    className="w-full px-3 py-2 flex items-center gap-2 bg-amber-500/15 active:bg-amber-500/25"
                  >
                    <span className="text-xl font-bold text-amber-300">巡回もれ</span>
                    {countBadge(overdueStores.length)}
                    <span className="text-xs text-muted">{overdueDays}日以上</span>
                    <DisclosureChevron open={overdueOpen} className="text-muted ml-auto" />
                  </button>
                  {overdueOpen && (
                  <div>
                    {overdueStores.map(o => (
                      <button
                        key={o.store_code}
                        type="button"
                        data-testid={`launcher-patrol-overdue-${o.store_code}`}
                        onClick={() => navigate(`/clawsupport/store/${o.store_code}`)}
                        className="w-full min-h-[44px] px-3 py-2 flex items-center gap-2 text-left active:bg-surface/60"
                      >
                        <span className="text-lg text-text truncate">{o.store_name || o.store_code}</span>
                        {o.area && <span className="shrink-0 text-xs text-muted">{o.area}</span>}
                        <span className="ml-auto shrink-0 text-lg font-bold tabular-nums text-amber-300">{overdueLabel(o)}</span>
                      </button>
                    ))}
                  </div>
                  )}
                </div>
              )}

              {/* 停止中: 常に最上部・常時展開(畳まない)。24h 超で行を強調(D-1122: 時間はアラート設定)。 */}
              {bySeverity.stopped.length > 0 && (
                <div data-testid="launcher-severity-stopped">
                  <div className="px-3 py-2 flex items-center gap-2 bg-red-500/15">
                    <span className="text-xl font-bold text-red-300">{SEVERITY_LABELS.stopped}</span>
                    {countBadge(bySeverity.stopped.length)}
                  </div>
                  <div>{bySeverity.stopped.map(a => renderAlertRow(a, alertT.alert_report_stale_stopped_hours))}</div>
                </div>
              )}

              {/* 不具合: D-344 で既定折たたみ(改善と同形)。展開時のみ D-295 エリア/店舗グルーピング。7日(=24*7h)超で行を強調(D-1122: 時間はアラート設定)。 */}
              {bySeverity.fault.length > 0 && (
                <div data-testid="launcher-severity-fault">
                  <button
                    type="button"
                    data-testid="launcher-severity-fault-toggle"
                    aria-expanded={faultOpen}
                    onClick={() => setFaultOpen(v => !v)}
                    className="w-full px-3 py-2 flex items-center gap-2 bg-surface active:bg-bg/40"
                  >
                    <span className="text-xl font-bold text-text">{SEVERITY_LABELS.fault}</span>
                    {countBadge(bySeverity.fault.length)}
                    <DisclosureChevron open={faultOpen} className="text-muted ml-auto" />
                  </button>
                  {faultOpen && <div>{renderGroupedAlerts(bySeverity.fault, alertT.alert_report_stale_fault_hours)}</div>}
                </div>
              )}

              {/* 改善: 既定で折りたたみ・件数バッジのみ、タップで展開。滞留は数えない(強調なし)。 */}
              {bySeverity.idea.length > 0 && (
                <div data-testid="launcher-severity-idea">
                  <button
                    type="button"
                    data-testid="launcher-severity-idea-toggle"
                    aria-expanded={ideaOpen}
                    onClick={() => setIdeaOpen(v => !v)}
                    className="w-full px-3 py-2 flex items-center gap-2 bg-surface active:bg-bg/40"
                  >
                    <span className="text-xl font-bold text-muted">{SEVERITY_LABELS.idea}</span>
                    {countBadge(bySeverity.idea.length)}
                    <DisclosureChevron open={ideaOpen} className="text-muted ml-auto" />
                  </button>
                  {ideaOpen && <div>{renderGroupedAlerts(bySeverity.idea, null)}</div>}
                </div>
              )}

              {/* IMPL_5: 全店取得の上限に達したら明示(黙って切らない)。 */}
              {alerts.length >= 200 && (
                <div className="px-3 py-3 text-center text-muted text-sm">
                  件数が多いため最新200件のみ表示
                  <button type="button" data-testid="launcher-alerts-truncated-more" onClick={() => navigate('/clawsupport/alerts')} className="ml-2 text-blue-400">一覧へ<LinkChevron /></button>
                </div>
              )}
            </div>
          )}
        </div>{/* /card-bottom(bg-surface rounded-b-2xl) */}
        {/* D-993: Face ID でログインの ON/OFF への入口。ヘッダ(D-341/D-852 の高さ)には触れず、スクロール領域の末尾に置く。
            使えない端末(WebAuthn 無し)には出さない。 */}
        {faceIdSupported && (
          <div className="px-4 pt-4 pb-6 text-center">
            <button
              type="button"
              data-testid="launcher-faceid-settings"
              onClick={() => navigate('/settings/face-id')}
              className="min-h-[44px] px-3 text-sm text-muted underline underline-offset-4 decoration-dotted active:opacity-70"
            >
              Face ID でログイン設定
            </button>
          </div>
        )}
      </div>{/* /スクロール領域(flex-1 overflow-y-auto) */}
      <UndoToast testId="launcher-undo-toast" toast={undoToast} busy={undoBusy}
        onUndo={handleUndoResolve} onClose={() => setUndoToast(null)} />
      <FeedbackSheet open={feedbackOpen}
        onClose={() => { setFeedbackOpen(false); replyBadge.refresh() }}
        onRepliesSeen={replyBadge.refresh}
        staffId={staffId} />
    </div>
  )
}
